import {MessageCircle, Syringe} from "@lucide/vue";
import {FunctionalComponent, markRaw, Raw} from "vue";

const TagService = () => {

    /**
     * Get the first emoji for a list of tags.
     */
    const firstIconForTags = (tags: { name: string }[]): Raw<FunctionalComponent> | null => {
        if (tags.length === 0) {
            return null;
        }

        const tag = tags[0];
        const emoji = iconForTag(tag);

        if (emoji) {
            return emoji;
        }

        return firstIconForTags(tags.slice(1));
    };

    /**
     * Get the icon name, depends on the tag name.
     */
    const iconForTag = (tag: { name: string }): Raw<FunctionalComponent> | null => {
        switch (tag.name) {
            case 'vaccination':
                return markRaw(Syringe);
            case 'interview':
                return markRaw(MessageCircle);
            default:
                return null;
        }
    };

    return {
        iconForTag,
        firstIconForTags
    };
};

export default TagService();
